import api from './api';

const priceScraperService = {
  /**
   * Lance le scraping manuellement
   */
  scrapeNow: async () => {
    const response = await api.post('/api/admin/prices/scrape');
    return response.data;
  },

  /**
   * Teste le scraping d'une URL spécifique
   */
  testUrl: async (url) => {
    const response = await api.post('/api/admin/prices/test-url', { url });
    return response.data;
  },

  /**
   * Teste le scraping d'une URL avec une variante spécifique
   */
  testUrlWithVariant: async (url, variantSelector) => {
    const response = await api.post('/api/admin/prices/test-url-variant', { 
      url, 
      variantSelector 
    });
    return response.data;
  },

  /**
   * Analyse une URL pour détecter les multiples prix
   */
  analyzeUrl: async (url) => {
    const response = await api.post('/api/admin/prices/analyze-url', { url });
    return response.data;
  },

  /**
   * Récupère l'historique des prix d'un produit
   */
  getProductPriceHistory: async (productId, days = 30) => {
    const response = await api.get(`/api/admin/prices/products/${productId}/history`, {
      params: { days }
    });
    return response.data;
  },

  /**
   * Récupère l'historique des prix d'une variante
   */
  getVariantPriceHistory: async (variantId, days = 30) => {
    const response = await api.get(`/api/admin/prices/variants/${variantId}/history`, {
      params: { days }
    });
    return response.data;
  },
};

export default priceScraperService;

